import axios from "axios";

// Resolve backend URL:
// - Local dev (localhost:3000) → use REACT_APP_BACKEND_URL env var
// - Preview / Production (anywhere else) → call same origin where the frontend is served.
//   This keeps the app working on preview AND on the deployed domain (nemmanagement.it)
//   without rebuilding when the backend host changes.
function resolveBackendUrl() {
    if (typeof window === "undefined") {
        return process.env.REACT_APP_BACKEND_URL || "";
    }
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
        return process.env.REACT_APP_BACKEND_URL || `${window.location.protocol}//${host}:8001`;
    }
    return window.location.origin;
}

const BACKEND_URL = resolveBackendUrl();
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "nm_auth_token";

export const tokenStore = {
    get: () => localStorage.getItem(TOKEN_KEY),
    set: (t) => localStorage.setItem(TOKEN_KEY, t),
    clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: false,
});

api.interceptors.request.use((config) => {
    const token = tokenStore.get();
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const mediaUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
    if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
    return url;
};

export const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_b40b39cf-c2da-4ed2-80fc-019c88d9c909/artifacts/wylixhzj_nem-logo-bianco-retina2.png";
export const LOGO_BLACK = "https://customer-assets.emergentagent.com/job_b40b39cf-c2da-4ed2-80fc-019c88d9c909/artifacts/h1f1sr9c_Logotipo-Nero.png";

// Broadcaster logos — original PNG with transparent background
export const BROADCASTERS_INLINE = [
    {
        key: "mediaset",
        name: "Mediaset",
        src: "https://customer-assets.emergentagent.com/job_nm-production-suite/artifacts/9grm5j2n_Mediaset_Logo.png",
    },
    {
        key: "sky",
        name: "Sky",
        src: "https://customer-assets.emergentagent.com/job_nm-production-suite/artifacts/7ppkov9f_Sky_TV_Logo.png",
    },
    {
        key: "sportitalia",
        name: "Sportitalia",
        src: "https://customer-assets.emergentagent.com/job_nm-production-suite/artifacts/bpekxd5n_sportitalia.png",
    },
];
